// @flow

import React from 'react';
import styled from 'styled-components';
import NavLink from '../Link';
import { FormattedMessage } from 'react-intl';
import Slider from 'react-slick';
import { breakpoint } from './breakpoints';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import LocaleCode from '../../providers/LocaleCode';

import Business from './assets/business.svg';
import Logo_profi from './assets/profi_grey.svg';
import Logo_profi_hover from './assets/profi.svg';
import Logo_joblist from './assets/joblist_grey.svg';
import Logo_joblist_hover from './assets/joblist.svg';
import Logo_simpals from './assets/simpals_grey.svg';
import Logo_simpals_hover from './assets/simpals.svg';
import Logo_999 from './assets/999_grey.svg';
import Logo_999_hover from './assets/999.svg';
import Logo_price from './assets/price_grey.svg';
import Logo_price_hover from './assets/price.svg';
import Logo_marketplace from './assets/market_grey.svg';
import Logo_marketplace_hover from './assets/market.svg';
import Email from './assets/email.svg';
import Phone from './assets/phone.svg';
import PrevArrow from './assets/left_arrow.svg';
import NextArrow from './assets/right_arrow.svg';

import CookieSettingsLink from '../CookieConsent/CookieSettingsLink';
import {
  COOKIE_POLICY_PATH,
  LEGAL_ORIGIN,
  PRIVACY_POLICY_PATH,
} from '../CookieConsent/constants';
import { UserInfoConsumer } from '../../contexts/UserInfo';
import { BUSINESS_999_URL_PATHS } from '../../constants';
import { format999RedirectUrl } from '../../routes';
type Props = {};

const SlickButton = ({ currentSlide, slideCount, children, ...props }) => (
  <span {...props}>{children}</span>
);

const settings = {
  dots: false,
  arrows: true,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  nextArrow: (
    <SlickButton>
      <i className="icon-custom icon-prev"></i>
    </SlickButton>
  ),
  prevArrow: (
    <SlickButton>
      <i className="icon-custom icon-next"></i>
    </SlickButton>
  ),
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
      },
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
  ],
};

const FooterStyled = styled.footer`
  position: relative;
  width: 100%;

  border-top: 1px solid #e6e6e6;
`;

const InnerWrapper = styled.div`
  margin: auto;
  max-width: 1154px;
  box-sizing: border-box;
  padding: 30px 15px;
  background-color: #fff;
  position: relative;

  .last_margin {
    margin-bottom: 20px;
  }

  ${breakpoint('tablet')`
    display: flex;
    justify-content: space-between;
    padding: 50px 15px;
    `}
`;

const Column = styled.div`
  margin-bottom: 20px;

  & > *:last-child {
    margin-bottom: 0;
  }

  ${breakpoint('tablet')`
    margin-bottom: 0;
    `}
`;

const Img = styled.img`
  height: 25px;
  padding-right: 52px;

  ${breakpoint('tablet')`
    height: 30px;
    `}
`;

const H3 = styled.h3`
  color: rgba(60, 64, 66, 0.8);
  font-size: 14px;
  font-weight: bold;
  line-height: 17px;
  margin-bottom: 12px;

  & > * {
    font-weight: bold;
    color: rgba(60, 64, 66, 0.8) !important;
  }
`;

const Text = styled.p`
  color: rgba(60, 64, 66, 0.6);
  font-size: 13px;
  line-height: 15px;
  margin-bottom: 8px;
  position: relative;

  &.with_svg {
    padding-left: 19px;

    &:before {
      content: '';
      background-repeat: no-repeat;
      position: absolute;
      width: 12px;
      height: 12px;
      left: 0;
      bottom: 0;
    }
  }

  &.email_svg:before {
    background-image: url(${Email});
  }

  &.phone_svg:before {
    background-image: url(${Phone});
  }
`;
const Item = styled.li`
  display: block;
`;
const Link = styled(NavLink)`
  color: rgba(60, 64, 66, 0.6);
  font-size: 13px;
  line-height: 15px;
  display: block;
  margin-bottom: 8px;
`;

const ExternalLink = styled.a`
  color: rgba(60, 64, 66, 0.6);
  font-size: 13px;
  line-height: 15px;
  display: block;
  margin-bottom: 8px;
`;

const FloatedText = styled(Text)`
  & > a {
    color: inherit;
  }

  ${breakpoint('tablet')`
    position: absolute;
    bottom: 30px;
    `}
`;
const GlobalLink = styled.a`
  color: rgba(60, 64, 66, 0.6);
  font-size: 13px;
  line-height: 15px;
  display: block;
  margin-bottom: 8px;
`;
const Wrapper = styled.div`
  border-top: 1px solid #f4f5f8;
  margin: auto;
  max-width: 1154px;
  box-sizing: border-box;
  padding: 16px 0px;
  background-color: #fff;
  .logo {
    display: block;
    margin: auto;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    ${breakpoint('xs')`
      width: 80px;
      height: 32px;
    `}
    ${breakpoint('md')`
      width: 90px;
      height: 36px;
    `}
    ${breakpoint('lg')`
      width: 130px;
      height: 52px;
    `}
    ${breakpoint('xl')`
      width: 160px;
      height: 64px;
    `}
    &.profi {
      background-image: url(${Logo_profi});
    }
    &.joblist {
      background-image: url(${Logo_joblist});
    }
    &.simpals {
      background-image: url(${Logo_simpals});
    }
    &.logo_999 {
      background-image: url(${Logo_999});
    }
    &.price {
      background-image: url(${Logo_price});
    }
    &.marketplace {
      background-image: url(${Logo_marketplace});
    }
    &:hover {
      &.profi {
        background-image: url(${Logo_profi_hover});
      }
      &.joblist {
        background-image: url(${Logo_joblist_hover});
      }
      &.simpals {
        background-image: url(${Logo_simpals_hover});
      }
      &.logo_999 {
        background-image: url(${Logo_999_hover});
      }
      &.price {
        background-image: url(${Logo_price_hover});
      }
      &.marketplace {
        background-image: url(${Logo_marketplace_hover});
      }
    }
  }
  .slick-list {
    ${breakpoint('xs')`
      width: calc(100% - 78px);
      margin: auto;
    `}
    ${breakpoint('sm')`
      width: 100%;
    `}
  }
  .slick-arrow {
    z-index: 2;
    &.slick-prev {
      left: 15px;
      width: 24px;
      height: 24px;
      &::before {
        background-image: url(${PrevArrow});
      }
    }
    &.slick-next {
      right: 15px;
      width: 24px;
      height: 24px;
      &::before {
        background-image: url(${NextArrow});
      }
    }
    &.slick-prev,
    &.slick-next {
      &::before {
        content: '';
        display: block;
        width: 24px;
        height: 24px;
        opacity: 1;
        color: #97989e;
      }
    }
  }
`;

const Footer = (props: Props) => (
  <LocaleCode>
    {(localeCode: string) => (
      <UserInfoConsumer>
        {() => (
          <FooterStyled>
            <InnerWrapper>
              <Column>
                <Img src={Business} />
              </Column>

              <Column>
                <H3>
                  <FormattedMessage
                    id="footer.ads"
                    defaultMessage="Объявления"
                  />
                </H3>
                <Link to="/business/effectiveness/">
                  <FormattedMessage
                    id="footer.ads.list"
                    defaultMessage="Список всех объявлений"
                  />
                </Link>
                <Link
                  to="/business/advanced-effectiveness/"
                  className="last_margin"
                >
                  <FormattedMessage
                    id="footer.ads.report"
                    defaultMessage="Общий отчет по объявлениям"
                  />
                </Link>
                <H3>
                  <FormattedMessage
                    id="footer.accounts"
                    defaultMessage="Аккаунты"
                  />
                </H3>
                <ExternalLink
                  href={format999RedirectUrl(
                    BUSINESS_999_URL_PATHS.CONNECTED_ACCOUNTS,
                  )}
                  target="_blank"
                >
                  <FormattedMessage
                    id="footer.connected"
                    defaultMessage="Подключенные аккаунты"
                  />
                </ExternalLink>
                <Link to="/control/history/" className="last_margin">
                  <FormattedMessage
                    id="footer.history"
                    defaultMessage="История действий"
                  />
                </Link>
                <H3>
                  <FormattedMessage
                    id="footer.finance"
                    defaultMessage="Финансы"
                  />
                </H3>
                <ExternalLink
                  href={format999RedirectUrl(
                    BUSINESS_999_URL_PATHS.CONNECTED_ACCOUNTS,
                  )}
                  target="_blank"
                >
                  <FormattedMessage
                    id="footer.transactions"
                    defaultMessage="Перевод средств между аккаунтами"
                  />
                </ExternalLink>
                <Link to="/business/finance/">
                  <FormattedMessage
                    id="footer.finance.report"
                    defaultMessage="Финансовый отчет"
                  />
                </Link>
                {/* <Link to="/subscribe/business/">
                  <FormattedMessage
                    id="footer.activation"
                    defaultMessage="Реквизиты"
                  />
                </Link> */}
                <ExternalLink
                  href={format999RedirectUrl(BUSINESS_999_URL_PATHS.TARIFFS)}
                  target="_blank"
                >
                  <FormattedMessage
                    id="footer.activation.pro"
                    defaultMessage="Настройки аккаунта"
                  />
                </ExternalLink>
              </Column>

              <Column>
                <H3>
                  <FormattedMessage
                    id="footer.analytics"
                    defaultMessage="Аналитика"
                  />
                </H3>
                <Link to="/analysis/trends/">
                  <FormattedMessage
                    id="footer.search.trends"
                    defaultMessage="Поисковые тренды"
                  />
                </Link>
                <Link to="/analysis/search/queries/">
                  <FormattedMessage
                    id="footer.search.top"
                    defaultMessage="Топ поисковых запросов"
                  />
                </Link>
                <Link to="/analysis/search/analytics/">
                  <FormattedMessage
                    id="footer.search.popularity"
                    defaultMessage="Анализ популярности слов"
                  />
                </Link>
                <Link to="/site/adverts/">
                  <FormattedMessage
                    id="footer.price.comparison"
                    defaultMessage="Оценка стоимости товаров"
                  />
                </Link>
                <Link to="/site/statistics/visits/">
                  <FormattedMessage
                    id="footer.category.timing"
                    defaultMessage="Время посещаемости категории"
                  />
                </Link>
                <Link to="/site/statistics/republish/" className="last_margin">
                  <FormattedMessage
                    id="footer.publication.timing"
                    defaultMessage="Время публикации объявлений"
                  />
                </Link>

                <H3 /* className="last_margin" */>
                  <ExternalLink
                    href={format999RedirectUrl(BUSINESS_999_URL_PATHS.API)}
                    target="_blank"
                  >
                    API
                  </ExternalLink>
                </H3>
                <Item onClick={props.onMenuClick}></Item>

                <H3>
                  <ExternalLink
                    href={format999RedirectUrl(BUSINESS_999_URL_PATHS.TARIFFS)}
                    target="_blank"
                  >
                    <Item
                      onClick={() => {
                        /* GA event */
                        (window.dataLayer || []).push({
                          event: 'business_activate',
                          action: 'start',
                          location: 'business_999',
                          button_location: 'footer',
                        });
                      }}
                    >
                      <FormattedMessage
                        id="footer.tarif"
                        defaultMessage="Тарифы"
                      />
                    </Item>
                  </ExternalLink>
                </H3>
              </Column>

              <Column>
                <H3>
                  <FormattedMessage
                    id="footer.working.time"
                    defaultMessage="График работы"
                  />
                </H3>
                <Text>
                  <FormattedMessage
                    id="footer.commercial"
                    defaultMessage="Коммерческий отдел"
                  />
                </Text>
                <Text>
                  09:00 - 18:00{' '}
                  <FormattedMessage
                    id="footer.working.days"
                    defaultMessage="с Пн - Пт"
                  />
                </Text>
                <Text className="with_svg phone_svg">+373 22 888 999</Text>
                <Text className="last_margin with_svg email_svg">
                  info@999.md
                </Text>
                <Text>
                  <FormattedMessage
                    id="footer.support"
                    defaultMessage="Служба поддержки, 24/7"
                  />
                </Text>
                <Text className="with_svg phone_svg">+373 22 888 002</Text>
                <Text className="last_margin with_svg email_svg">
                  info@999.md
                </Text>
                <ExternalLink
                  href={`${LEGAL_ORIGIN}/${localeCode}${PRIVACY_POLICY_PATH}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage
                    id="footer.privacy.policy"
                    defaultMessage="Политика конфиденциальности"
                  />
                </ExternalLink>
                <ExternalLink
                  href={`${LEGAL_ORIGIN}/${localeCode}${COOKIE_POLICY_PATH}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage
                    id="footer.cookie.policy"
                    defaultMessage="Политика использования Cookie"
                  />
                </ExternalLink>
                {/* GDPR: withdrawing consent must stay as easy as granting it. */}
                <CookieSettingsLink />
              </Column>
              <FloatedText className="last_margin">
                © {new Date().getFullYear()}{' '}
                <a href="http://simpals.com/">Simpals</a>
              </FloatedText>
            </InnerWrapper>
            <Wrapper className="footer_partners">
              <Slider {...settings}>
                <div>
                  <a
                    href={`https://profi.md/`}
                    className="logo profi"
                    target="_blank"
                  >
                    <span></span>
                  </a>
                </div>
                <div className="">
                  <a
                    href={`https://joblist.md/`}
                    className="logo joblist"
                    target="_blank"
                  >
                    <span></span>
                  </a>
                </div>
                <div className="">
                  <a
                    href={`https://simpals.com/`}
                    className="logo simpals"
                    target="_blank"
                  >
                    <span></span>
                  </a>
                </div>
                <div className="">
                  <a
                    href={`https://999.md/`}
                    className="logo logo_999"
                    target="_blank"
                  >
                    <span></span>
                  </a>
                </div>
              </Slider>
            </Wrapper>
          </FooterStyled>
        )}
      </UserInfoConsumer>
    )}
  </LocaleCode>
);

export default Footer;
